import "./CategoryCard.css";
import { Typography } from "@mui/material";
import React, { useState } from "react";
import NoImageIcon from "@mui/icons-material/Image"; // Replace this with your icon or avatar

export default function CategoryCard({
  baseUrl,
  category,
  selectedCategory,
  setCategoryId,
}) {
  const [imageError, setImageError] = useState(false);

  const imageUrl = `${baseUrl}Category/${category?.Cd}.jpg`;

  return (
    <div className="category-card">
      <div
        className="category-img position-relative"
        style={{
          boxShadow:
            selectedCategory === category?.Cd ? "0 0 8px blue" : "0 0 8px gray",
        }}
        onClick={() => setCategoryId(category?.Cd)}
      >
        {imageError ? (
          <NoImageIcon
            style={{
              fontSize: "4rem",
              color: "gray",
              display: "block",
              margin: "auto",
              cursor: "pointer",
            }}
          />
        ) : (
          <img
            src={imageUrl}
            alt={category?.Name1}
            loading="lazy"
            onError={() => setImageError(true)}
          />
        )}
      </div>
      <Typography className="category-title">{category?.Name1}</Typography>
    </div>
  );
}
